import { IQualificationConfig } from '../services/nestjs-base-api';

export function businessModelLabel(
  config: IQualificationConfig | null | undefined,
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  return config?.businessModels?.find((m) => m.value === value)?.label ?? value;
}

export function productCategoryLabel(
  config: IQualificationConfig | null | undefined,
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  const fromCategories = config?.productCategories?.find(
    (c) => c.value === value,
  )?.label;
  if (fromCategories) return fromCategories;
  // Synthetic umbrella values (e.g. PERISHABLE_CONSUMER) aren't quiz options —
  // their label lives in reverseDefaults. Config-driven, no hardcoded labels.
  const fromReverse = config?.reverseDefaults
    ? Object.values(config.reverseDefaults).find(
        (r) => r.productCategory === value,
      )?.productCategoryLabel
    : undefined;
  return fromReverse ?? value;
}
